import { render, staticRenderFns } from "./TemplateInput.vue?vue&type=template&id=6fd877b0&scoped=true"
import script from "./TemplateInput.vue?vue&type=script&lang=js"
export * from "./TemplateInput.vue?vue&type=script&lang=js"
import style0 from "./TemplateInput.vue?vue&type=style&index=0&id=6fd877b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd877b0",
  null
  
)

export default component.exports